/* Scientist kiwi variant — lab goggles with strap and beaker. */

import type { KiwiPalette } from "../kiwiPalettes";

export function renderScientist(p: KiwiPalette) {
  return (
    <>
      {/* Goggle strap — goes over top of head */}
      <rect x="6" y="6" width="2" height="4" fill={p.accent} opacity={0.35} />
      <rect x="8" y="4" width="16" height="2" fill={p.accent} opacity={0.35} />
      <rect x="24" y="6" width="2" height="4" fill={p.accent} opacity={0.35} />

      {/* Body */}
      <path d="M12 6H20V8H24V10H26V18H24V22H20V24H12V22H8V18H6V10H8V8H12V6Z" fill={p.body} />

      {/* Tuft */}
      <path d="M10 4H12V6H10V4ZM12 2H14V4H12V2Z" fill={p.body} />

      {/* Highlight */}
      <rect x="20" y="14" width="2" height="2" fill={p.highlight} opacity={0.3} />

      {/* Beak */}
      <path d="M4 12H6V14H4V12ZM2 14H4V16H2V14ZM2 16H4V18H2V16ZM4 18H6V20H4V18Z" fill={p.beak} />

      {/* Lab goggles — thicker frames than nerd glasses */}
      <rect x="8" y="10" width="6" height="6" fill={p.eyeBg} />
      <rect x="15" y="10" width="6" height="6" fill={p.eyeBg} />
      {/* Left goggle frame */}
      <rect x="7" y="9" width="8" height="1" fill={p.accent} opacity={0.7} />
      <rect x="7" y="16" width="8" height="1" fill={p.accent} opacity={0.7} />
      <rect x="7" y="9" width="1" height="8" fill={p.accent} opacity={0.7} />
      {/* Right goggle frame */}
      <rect x="15" y="9" width="7" height="1" fill={p.accent} opacity={0.7} />
      <rect x="15" y="16" width="7" height="1" fill={p.accent} opacity={0.7} />
      <rect x="21" y="9" width="1" height="8" fill={p.accent} opacity={0.7} />
      {/* Bridge */}
      <rect x="14" y="11" width="1" height="4" fill={p.accent} opacity={0.6} />
      {/* Lens reflections */}
      <rect x="9" y="11" width="2" height="1" fill={p.highlight} opacity={0.5} />
      <rect x="16" y="11" width="2" height="1" fill={p.highlight} opacity={0.5} />

      {/* Pupils */}
      <rect x="10" y="12" width="2" height="2" fill={p.pupil} />
      <rect x="17" y="12" width="2" height="2" fill={p.pupil} />

      {/* Beaker/flask held on right side */}
      <rect x="27" y="12" width="2" height="2" fill={p.eyeBg} opacity={0.5} />
      <rect x="26" y="14" width="4" height="6" fill={p.eyeBg} opacity={0.5} />
      {/* Liquid inside beaker */}
      <rect x="26" y="17" width="4" height="3" fill={p.accent} opacity={0.4} />
      {/* Bubbles */}
      <rect x="27" y="16" width="1" height="1" fill={p.accent} opacity={0.25} />
      <rect x="29" y="15" width="1" height="1" fill={p.accent} opacity={0.2} />

      {/* Feet */}
      <path d="M12 24H14V28H12V24ZM10 28H16V30H10V28Z" fill={p.body} />
      <path d="M18 24H20V28H18V24ZM16 28H22V30H16V28Z" fill={p.body} />
    </>
  );
}
